export default class Constants {
  static CONFIG = {
    INFO: 'info'
  }
  static sessionConstants = {
    EMAIL: 'email',
    ADDRESSTEXT: 'addressText',
    COMPANYADDRESS: 'companyAddress',
    SELECTEDGBGPOSTCODE: 'selectedGBGPostcode',
    SELECTEDGBGADDRESS: 'selectedGBGAddress',
    METERLIST: 'meterList',
    METERDETAILS: 'meterDetails',
    GBGADDRESSOBJ: 'gbgAddressObj',
    MASTERDATA: 'masterData',
    USERDETAILS: 'userDetails',
    POTENTIALSAVINGS: 'potentialSavings',
    POTENTIALCARBONSAVINGS: 'potentialCarbonSavings',
    TOTALCOST: 'totalCost',
    RECOMMENDATIONSTATUS: 'recommendationStatus',
    LIGHTING: 'lightingRecommendation',
    DASHBOARD: 'dashboard',
    INSULATION: 'insulationRecommendation',
    HEATPUMP: 'heatpumpRecommendation',
    SOLARPANEL: 'solarpanelRecommendation',
    BOILER: 'boilerRecommendation',
    VO: 'voltageOptimisationRecommendation',
    VOData: 'voltageOptimisationData',
    SELECTEDSITE: 'selectedSite',
    SELECTED_COMPANY: 'selectedCompany',
    ALREADYREGISTERED: 'alreadyRegistered',
    ACTIVETAB: 'activeTab',
    RETURNURL: 'returnUrl',
    CONSENT: 'consent',
    ADDRESSLINE: 'addressLine',
    ISNEWJOURNEY: 'isNewJourney',
    ISVERIFYEMAIL: 'isVerifyEmail',
    ISENABLE: 'isEnable',
    CORRELATIONID: 'correlationId',
    ISELIGIBLEMETER: 'isEligibleMeter',
    BEHAVIOURALINSIGHTS: 'behaviouralInsights',
    REDIRECTIONURL: 'redirectionUrl',
    SHOWLOAPOPUP: 'showLOAPopup',
    COUNTER: '_c_',
    ADD_COMPANY_DATA: 'addCompanyData',
    COMPANY_SITE_DATA: 'companySiteData',
    SELECTED_SITE_DATA: 'selectedSiteData',
    ADDED_SITE_FROM_PROFILE: 'addSiteFromProfile',
    NEW_SITE_ADDED: 'newSiteAdded',
    EPC_SITE_DETAILS: 'epcSiteDetails',
    RELOAD_RECOMMENDATION: 'reloadRecommendation',
    SIGNATURE: 'signature',
  };
  static recommendation: any = {
    LIGHTING: 'lighting',
    INSULATION: 'insulation',
    HEATPUMP: 'heatpump',
    SOLARPANEL: 'solarpanel',
    BOILER: 'boiler',
    VOLTAGEOPTIMISATION: 'voltageOptimisation'
  }
  static recommendationType: any = {
    lighting: 'Lighting',
    insulation: 'Insulation',
    heatpump: 'Heat Pump',
    solarpanel: 'Solar',
    boiler: 'Boiler',
    voltageOptimisation: 'Voltage Optimisation'
  }
  static NAMEREGEX: RegExp = new RegExp(
    `/^([A-Z]|[a-z]|[\u00c0-\u017F])+([s|-|']([A-Z]|[a-z]|[\u00c0-\u017F])*)*$/`
  );
  static EMAILREGEX: RegExp = new RegExp(
    `/^(([^<>()[]\\.,;:s@"]+(.[^<>()[]\\.,;:s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/`
  );
  static PostCodeRegExp: RegExp = new RegExp(/([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/gm);
  static NumberRegex: RegExp = /^[0-9]*$/;
  static IgnoreKeys: Array<string> = [
    'Backspace',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
    'Home',
    'End',
    'Tab',
  ];
  static ERROR_MESSAGES = {
    DOMESTIC_METER: 'DOMESTIC_METER',
    SITE_EXIST: 'SITE_EXIST',
  };
  static CompanyType = [
    {
      id: 1,
      name: "Limited Company",
      display_name: "LTD",
      image: "./assets/images/common/portfolio.png"
    },
    {
      id: 2,
      name: "Charity",
      display_name: "Charity",
      image: "./assets/images/common/charity.png"
    },
    {
      id: 3,
      name: "Sole Trader",
      display_name: "Sole trader",
      image: "./assets/images/common/businessman.png"
    }
  ]
  static ListOfPropertiesType: any[] = [
    { name: 'A1/A2 Retail and Financial/Professional services' },
    { name: 'A3/A4/A5 Restaurant and Cafes/Drinking Establishments and Hot Food takeaways' },
    { name: 'Airport terminals' },
    { name: 'B1 Offices and Workshop businesses' },
    { name: 'B2 to B7 General Industrial and Special Industrial Groups' },
    { name: 'B8 Storage or Distribution' },
    { name: 'Bus station/train station/seaport terminal' },
    { name: 'C1 Hotels' },
    { name: 'C2 Residential Institutions - Hospitals and Care Homes' },
    { name: 'C2 Residential Institutions - Residential schools' },
    { name: 'C2 Residential Institutions - Universities and colleges' },
    { name: 'C2A Secure Residential Institutions' },
    { name: 'Community/day centre' },
    { name: 'Crown and county courts' },
    { name: 'D1 Non-residential Institutions - Community/Day Centre' },
    { name: 'D1 Non-residential Institutions - Crown and County Courts' },
    { name: 'D1 Non-residential Institutions - Education' },
    { name: 'D1 Non-residential Institutions - Libraries Museums and Galleries' },
    { name: 'D1 Non-residential Institutions - Primary Health Care Building' },
    { name: 'D2 General Assembly and Leisure plus Night Clubs and Theatres' },
    { name: 'Dwelling' },
    { name: 'Emergency services' },
    { name: 'Further education universities' },
    { name: 'Hospital' },
    { name: 'Hotel' },
    { name: 'Industrial process building' },
    { name: 'Launderette' },
    { name: 'Libraries/museums/galleries' },
    { name: 'Miscellaneous 24hr activities' },
    { name: 'Nursing residential homes and hostels' },
    { name: 'Office' },
    { name: 'Others - Car Parks 24 hrs' },
    { name: 'Others - Emergency services' },
    { name: 'Others - Miscellaneous 24hr activities' },
    { name: 'Others - Passenger terminals' },
    { name: 'Others -Telephone exchanges' },
    { name: 'Others - Stand alone utility block' },
    { name: 'Primary health care buildings' },
    { name: 'Primary school' },
    { name: 'Prisons' },
    { name: 'Residential spaces' },
    { name: 'Restaurant/public house' },
    { name: 'Retail' },
    { name: 'Retail warehouses' },
    { name: 'Secondary school' },
    { name: 'Social clubs' },
    { name: 'Sports centre/leisure centre' },
    { name: 'Sports ground arena' },
    { name: 'Telephone exchanges' },
    { name: 'Theatres/cinemas/music halls and auditoria' },
    { name: 'Warehouse and storage' },
    { name: 'Workshops/maintenance depot' }
  ];
  static ListOfAgeOfBuilding: any[] = [
    { year: '<1899' },
    { year: '1900-29' },
    { year: '1930-39' },
    { year: '1940-49' },
    { year: '1950-69' },
    { year: '1970-79' },
    { year: '1980-89' },
    { year: '1990-99' },
    { year: '2000-2012' },
    { year: '2013-' },
  ];
  static LOAFileConfig = {
    MaxSize: 5242880, // Size in bytes
    FileType: ['pdf']
  }
  static Regex = {
    firstName: /^(?![-'])[a-zA-Z-\' ]*$/,
    lastName: /^(?![-'])[a-zA-Z-\' ]*$/,
    Mobile: /^(01[0-9]{9}|02[0-9]{9}|03[0-9]{9}|04[0-9]{9}|05[0-9]{9}|06[0-9]{9}|07[0-9]{9}|08[0-9]{9}|09[0-9]{9})$/,
    Email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    Postcode: /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/,
    MPAN: /^(?=\d{10,13}$)\d+$/,
    MPRN: /^(?=\d{6,10}$)\d+$/,
  }
  static METER_PROFILE:any = {
    '01': 'Domestic',
    '02': 'Domestic Economy 7',
    '03': 'Non Domestic',
    '04': 'Non Domestic Economy 7',
    '05': 'Non Domestic MD-20',
    '06': 'Non Domestic MD-30',
    '07': 'Non Domestic MD-40',
    '08': 'Non Domestic MD',
    '00': 'Half Hourly'
  }
  static USER_TYPE = {
    BROKER: 'BROKER',
    CUSTOMER: 'CUSTOMER',
    CONTACT: 'CONTACT'
  }
  static HTTP_ERROR = {
    GENERIC_ERROR: 'We\'re having trouble retrieving the information you requested. Please try again later. If the issue persists, feel free to contact support.',
    INTERNAL_ERROR: 'Internal server error, try again later',
  }
  static POPUP_TYPES = {
    LOA: 'LOA',
    REVIEW_INFO_BACK_ACTION: 'REVIEW_INFO_BACK_ACTION',
    ADD_METER: 'ADD_METER',
    DELETE_METER: 'DELETE_METER',
    DELETE_SITE: 'DELETE_SITE',
  }
  static LOA_STATUS = {
    SIGNED: 'SIGNED',
    AWAITING: 'AWAITING',
  }
  static CACHE_STATUS = {
    PENDING : 'pending',
    AVAILABLE : 'available',
  }
  static HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    ACCEPTED: 202,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
    BAD_GATEWAY: 502,
    SERVICE_UNAVAILABLE: 503,
  }

  static TIMELINE_TYPE = {
    MONTH: 'month',
    YEAR: 'year',
  }

  static GRAPH_FUEL_TYPE = {
    COMBINED: 'Combined',
    ELEC: 'Elec',
    GAS: 'Gas',
  }

  static PERMISSIONS = [
    {label: 'View', value: 'view'},
    {label: 'Edit', value: 'edit'},
    {label: 'Remove access', value: 'remove'},
  ]
}